import React, { useState } from "react";
import { MdEmail, MdPhone } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import "./contactus.css";
import { useSettings } from "../SettingsContext";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const { settings } = useSettings();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
    alert("Your message has been sent successfully ✅");
  };

  // لو لسه الـ settings محملةش
  if (!settings) {
    return <div className="contact-container">Loading...</div>;
  }

  return (
    <div className="contact-container">
      <div className="contact-card">
        {/* Left - Form */}
        <div className="contact-form">
          <h2>Contact Us</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="5"
            ></textarea>
            <button type="submit">Send Message</button>
          </form>
        </div>

        {/* Right - Info */}
        <div className="contact-info">
          <h2>Get in Touch</h2>
          <p>
            Have questions about our tours or packages? Reach us via email,
            phone, or WhatsApp.
          </p>

          {settings.email && (
            <div className="info-item">
              <MdEmail className="icon" />
              <a href={`mailto:${settings.email}`}>{settings.email}</a>
            </div>
          )}

          {settings.phone && (
            <div className="info-item">
              <MdPhone className="icon" />
              <a href={`tel:${settings.phone}`}>{settings.phone}</a>
            </div>
          )}

          {settings.phone && (
            <div className="info-item">
              <FaWhatsapp className="icon whatsapp" />
              <a
                href={`https://wa.me/${settings.phone}`}
                target="_blank"
                rel="noreferrer"
              >
                Chat on WhatsApp
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
